<template>
  <div class="home-v2">
    <Loading v-if="$store.state.globalLoading" />
    <div class="request-nav">
      <div class="request-nav request-menus">
        <div class="request-menus__list">
          <div
            style="color:#cc3333; fontWeight: bold; cursor: pointer"
            @click="requestHome()"
          >
            MY REQUEST
          </div>
          <div class="hover-red" @click="newVendor()">VENDOR BARU</div>
          <div class="hover-red" @click="extendToSap()">EXTEND TO SAP</div>
          <div class="hover-red" @click="praqualifikasi()">PRAQUALIFIKASI</div>
          <div class="hover-red" @click="blockVendor()">BLOCK VENDOR</div>
          <div class="hover-red" @click="unblockVendor()">UNBLOCK VENDOR</div>
        </div>
        <div class="request-menus__search">
          <div v-if="$get($store, 'state.permissions.69.allow')">Filter:</div>
          <div
            class="request-menus__search__row-setting"
            v-if="$get($store, 'state.permissions.69.allow')"
          >
            <b-form-select
              v-model="choosedFilter"
              :options="filter"
              class="total-rows"
            ></b-form-select>
          </div>
          <div>Total Data:</div>
          <div class="request-menus__search__row-setting">
            <b-form-select
              v-model="perPage"
              :options="modes"
              class="total-rows"
            ></b-form-select>
          </div>
          <div
            class="request-menus__search__search-input"
            v-if="$get($store, 'state.permissions.70.allow')"
          >
            <input
              type="text"
              v-model="search"
              placeholder="Search"
              @keydown.enter="runSearch()"
            />
            <div>
              <strong class="text-danger"
                ><i
                  @click="clearSearch()"
                  class="fas fa-times pointer mr10"
                  v-if="search && search != ''"
                ></i
                ><i class="fas fa-search pointer" @click="runSearch()"></i
              ></strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="request-container">
      <router-view v-if="$get($store, 'state.permissions.64.allow')" />
    </div>
    <transition name="fade">
      <div
        class="modal-level2-container"
        v-show="$store.state.modalStore.showModalLevel1"
      >
        <div class="modal-level2-dialog">
          <div class="modal-level2-content">
            <div class="modal-level2-body">
              <div class="modal-button-close">
                <i class="far fa-times-circle" @click="closeModal()"></i>
              </div>
              <Validation />
            </div>
          </div>
        </div>
      </div>
    </transition>
    <ModalExtendSap v-if="$store.state.modalReqApp.modalExtendSap" />
    <ModalBlockVendor v-if="$store.state.modalReqApp.modalBlockVendor" />
    <ModalUnblockVendor v-if="$store.state.modalReqApp.modalUnblockVendor" />

    <ModalViewExtend v-if="$store.state.modalReqApp.modalViewExtend" />
    <ModalViewBlock v-if="$store.state.modalReqApp.modalViewBlock" />
    <ModalViewUnblock v-if="$store.state.modalReqApp.modalViewUnblock" />

    <ModalPraqualifikasi v-if="$store.state.modalReqApp.modalPraqualifikasi" />
  </div>
</template>
<script>
export default {
  components: {
    Validation: () => import('@/views/Validation/index'),
    ModalExtendSap: () => import('@/components/modal/ExtendSap.vue'),
    ModalBlockVendor: () => import('@/components/modal/BlockVendor.vue'),
    ModalUnblockVendor: () => import('@/components/modal/UnblockVendor.vue'),

    ModalViewExtend: () => import('@/components/modal/ViewExtendToSAP.vue'),
    ModalViewBlock: () => import('@/components/modal/ViewBlockVendor.vue'),
    ModalViewUnblock: () => import('@/components/modal/ViewUnblockVendor.vue'),

    ModalPraqualifikasi: () =>
      import('@/components/modal/praqualifikasi/Praqualifikasi.vue'),

    Loading: () => import('@/components/V2/GlobalLoading'),
  },
  data() {
    return {
      modes: [5, 10, 15, 20, 25],
      filter: [
        {
          value: 0,
          text: 'Semua',
        },
        {
          value: 1,
          text: 'Created',
        },
        {
          value: 2,
          text: 'Waiting for SIPM Approve',
        },
        {
          value: 3,
          text: 'Waiting for Ticket Review',
        },
        {
          value: 4,
          text: 'Ticket Rejected',
        },
        {
          value: 5,
          text: 'Ticket Approved',
        },
        {
          value: 6,
          text: 'Waiting for Vendor FeedBack',
        },
        {
          value: 7,
          text: 'Vendor FeedBack',
        },
        {
          value: 8,
          text: 'Waiting for Validation',
        },
        {
          value: 9,
          text: 'Waiting for Head SIPM Approve',
        },
        {
          value: 10,
          text: 'Postpone',
        },
        {
          value: 11,
          text: 'Vendor Rejected',
        },
        {
          value: 12,
          text: 'Vendor Approved',
        },
        {
          value: 13,
          text: 'Vendor Registered',
        },
        {
          value: 14,
          text: 'Vendor Deleted',
        },
        {
          value: 15,
          text: 'Waiting for Operational Compliance Check',
        },
        {
          value: 16,
          text: 'Waiting for Head Operational Compliance Check',
        },
        {
          value: 17,
          text: 'K3L Approved',
        },
        {
          value: 18,
          text: 'Waiting for HSE Check',
        },
        {
          value: 19,
          text: 'Waiting for Head HSE Check',
        },
        {
          value: 20,
          text: 'Waiting for KTT Check',
        },
        {
          value: 21,
          text: 'KPLH Approved',
        },
      ],
    }
  },
  computed: {
    choosedFilter: {
      get() {
        this.$store.state.myRequest.choosedFilter
      },
      set(newValue) {
        this.$store.commit('myRequest/SET_DATA', {
          name: 'choosedFilter',
          value: newValue,
        })

        this.$store.dispatch('myRequest/getRequest', { change: true })
      },
    },
    perPage: {
      get: function() {
        return this.$store.state.myRequest.perPage
      },
      set: function(newValue) {
        this.$store.dispatch('myRequest/setPagination', {
          name: 'perPage',
          value: newValue,
        })
      },
    },
    search: {
      get() {
        return this.$store.state.myRequest.search
      },
      set(newValue) {
        this.$store.commit('myRequest/SET_DATA', {
          name: 'search',
          value: newValue,
        })
      },
    },
  },
  methods: {
    clearSearch() {
      this.$store.commit('myRequest/SET_DATA', {
        name: 'search',
        value: null,
      })
      this.runSearch()
    },
    runSearch() {
      this.$store.dispatch('myRequest/getRequest', {
        change: true,
      })
    },
    requestHome() {
      this.$router.push({ path: '/myrequest' })
    },
    newVendor() {
      if (this.$get(this.$store, 'state.permissions.65.allow')) {
        this.$router.push({ path: '/myrequest/new/1' })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    praqualifikasi() {
      if (this.$get(this.$store, 'state.permissions.66.allow')) {
        this.$store.commit('modalReqApp/SET_VALUE', {
          name: 'modalPraqualifikasi',
          value: true,
        })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    extendToSap() {
      if (this.$get(this.$store, 'state.permissions.66.allow')) {
        this.$store.commit('modalReqApp/SET_VALUE', {
          name: 'modalExtendSap',
          value: true,
        })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    blockVendor() {
      if (this.$get(this.$store, 'state.permissions.67.allow')) {
        this.$store.commit('modalReqApp/SET_VALUE', {
          name: 'modalBlockVendor',
          value: true,
        })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    unblockVendor() {
      if (this.$get(this.$store, 'state.permissions.68.allow')) {
        this.$store.commit('modalReqApp/SET_VALUE', {
          name: 'modalUnblockVendor',
          value: true,
        })
      } else {
        this.$store.commit('DONT_HAVE_PERMISSIONS')
      }
    },
    closeModal() {
      this.$store.commit('modalStore/SET_MODAL_LEVEL1', false)
    },
  },
}
</script>
